<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { startSosMonitor } from "@/until/sosMonitor";
import { unlockAlarmSound, setAlarmSoundType, previewAllAlarmSounds, playAlarmSound, stopAlarmSound, recheckCustomMp3, getCustomAlarmMp3Url, setAlarmDebug, setAlarmBadge } from "@/until/alarmSound";
export default {
  mounted() {
    // 全局 SOS 报警监控: 任意页面有新报警都响铃
    startSosMonitor();
    // 内置音色可选: alarm | siren | urgent | bell (放了 public/alarm/custom.mp3 则优先用自定义mp3)
    setAlarmSoundType("bell");
    // 现场调音钩子: 控制台 __alarm.preview() 试听全部 / __alarm.set('siren') 切换 / __alarm.play() 立即播一次
    window.__alarm = {
      set: setAlarmSoundType,
      preview: previewAllAlarmSounds,
      play: playAlarmSound,
      stop: stopAlarmSound,
      recheck: recheckCustomMp3,
      url: getCustomAlarmMp3Url(),
      debug: setAlarmDebug,
      badge: setAlarmBadge,
      testMp3: () => { const a = new Audio(getCustomAlarmMp3Url()); a.volume = 1; return a.play(); },
    };
    // 默认打开诊断日志, 不需要可以控制台 __alarm.debug(false) 关掉
    setAlarmDebug(true);
    // URL 带 ?alarmDebug=1 自动弹屏角标(手机上没控制台时用)
    if (typeof window !== "undefined" && /[?&]alarmDebug=1\b/.test(window.location.search)) {
      setAlarmBadge(true);
    }
    // 浏览器自动播放限制: 首次交互解锁音频
    // PC 监听 click, 手机额外监听 touchstart(触摸时 iOS 才算手势)
    document.addEventListener("click", unlockAlarmSound, { once: true });
    document.addEventListener("touchstart", unlockAlarmSound, { once: true, passive: true });
  },
};
</script>

<style lang="scss">
#app{
  width: 100%;
  height: 100%;
}
</style>